import { render } from "./StatusBasedBilledCases.vue?vue&type=template&id=4f13c3e2"
import script from "./StatusBasedBilledCases.vue?vue&type=script&lang=js"
export * from "./StatusBasedBilledCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/StatusBasedBilledCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f13c3e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f13c3e2', __exports__)) {
    console.log('reload')
    api.reload('4f13c3e2', __exports__)
  }
  
  module.hot.accept("./StatusBasedBilledCases.vue?vue&type=template&id=4f13c3e2", () => {
    console.log('re-render')
    api.rerender('4f13c3e2', render)
  })

}


export default __exports__